const getters = {
  /** User variables */
  FullName: (state) => state.user.FullName,
  NumSystem: (state) => state.user.Num_System,
  UnreadMessagesCount: (state) => state.user.UnreadMessagesCount,
  ImageUrl: (state) => state.user.ImageUrl,

  userInfo: (state) => state.user.userInfo,
  token: (state) => state.user.token,
  /** global variables */
  headerTitle: (state) => state.global.headerTitle,
  //showDetails: (state) => state.global.showDetails,
  isMobile: (state) => state.global.mobile,
  snackbar: (state) => state.global.snackbar,
  progress: (state) => state.global.progress,
  apiRunning: (state) => state.global.apiRunning,
  menuOptions: (state) => state.user.menuOptions,
  dialog: (state) => state.global.dialog,
  searchInput: (state) => state.global.searchInput,
  searchMenu: (state) => state.global.searchMenu,
  tableText: (state) => state.global.tableText,
  selectedMenu: (state) => state.global.selectedMenu,
  /** message variables */
  messages: (state) => state.message.messages,
  cycles: (state) => state.cycle.cycles,
  openCycles: (state) => state.cycle.openCycles,
  payehha: (state) => state.payeh.payeh,
  openClasses: (state) => state.hozoor.classes,
  students: (state) => state.hozoor.students,
  exams: (state) => state.cycle.exams,
  khoroojInfo: (state) => state.khorooj.khoroojInfo,
  khoroojHistory: (state) => state.khorooj.history,
  lastKhorooj: (state) => state.khorooj.last,
  resumeShakheses: (state) => state.resume.shakheses,
  resumeReportCard: (state) => state.resume.reportCard,
  schools: (state) => state.transfer.schools,
  ostanCities: (state) => state.schools.ostanCities,
  schoolInfo: (state) => state.schools.schoolInfo,
  schoolPersonnel: (state) => state.schools.schoolPersonnel,
  schoolTeachers: (state) => state.schools.schoolTeachers,
  schoolPictures: (state) => state.schools.schoolPictures,
  transferHistory: (state) => state.transfer.history,
  salaries: (state) => state.salary.salaries,
  salaryDetails: (state) => state.salary.details,
  homeRequestHistory: (state) => state.homeRequest.history,
  activeHomeRequest: (state) => state.homeRequest.active,
  currentHomeRequest: (state) => state.homeRequest.current,
  registers: (state) => state.sabtenam.registers,
  registersHistory: (state) => state.sabtenam.history,
  links: (state) => state.links.links,
  receivers: (state) => state.ertebat.receivers,
  letters: (state) => state.ertebat.messages,
  madrakInfo: (state) => state.madrak.madrakInfo,
  madrakHistory: (state) => state.madrak.history,
  tadrisInfo: (state) => state.tadris.tadrisInfo,
  tadrisDoreh: (state) => state.tadris.tadrisDoreh,
  dorehSchool: (state) => state.tadris.dorehSchool,
  maritalInfo: (state) => state.marital.maritalInfo,
  maritalHistory: (state) => state.marital.history,
  morkhasiInfo: (state) => state.morkhasi.morkhasiInfo,
  morkhasiHistory: (state) => state.morkhasi.history,
  tadrisPermissionReshte: (state) => state.tadrisPermission.reshte,
  tadrisPermissionEmtiazDetails: (state) =>
    state.tadrisPermission.emtiazDetails,
  tadrisPermissionHistory: (state) => state.tadrisPermission.history,
  deleteableCourses: (state) => state.deleteCourse.courses,
  deletedCoursesHistory: (state) => state.deleteCourse.history,
  changePictureHistory: (state) => state.picture.history,
};
export default getters;
